// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1xdQe","header":"ClearentDisclaimer_header__1HhQK","inner":"ClearentDisclaimer_inner__mGIDz"};